import { createFileRoute, redirect } from '@tanstack/react-router'
import * as React from 'react'
import { resolveSession } from '../features/auth/session'
import { canSeeProjects, projectLaneDefinition } from '../features/projects/api'
import { PortfolioScreen, type PortfolioSearch, parsePortfolioSearch } from '../features/projects/portfolio'

export const Route = createFileRoute('/projects')({
  validateSearch: (raw: Record<string, unknown>): PortfolioSearch => parsePortfolioSearch(raw),
  beforeLoad: async ({ context }) => {
    const session = await resolveSession(context.queryClient)
    if (session.kind !== 'signed_in') return
    if (session.me.ui_mode === 'simple') throw redirect({ to: '/my-day' })
    if (!canSeeProjects(session.me.role)) throw redirect({ to: '/' })
  },
  component: function ProjectsRoute() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const onSearch = React.useCallback(
      (patch: Partial<PortfolioSearch>) =>
        void navigate({ search: (previous: PortfolioSearch) => parsePortfolioSearch({ ...previous, ...patch }), replace: true }),
      [navigate],
    )
    return <PortfolioScreen lane={projectLaneDefinition('needs_my_move')} search={search} onSearch={onSearch} />
  },
})
